import { init } from './app';

init();



// WEBPACK FOOTER //
// ./rss-feed-widget/index.js